import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    AfterViewChecked,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from 'app/services/common-data.service';
import {ISubscription} from "rxjs/Subscription";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {CodeNameTranslate} from "app/shared/models/code-name-translate";
import {Formatters} from "../../../slick-grid/models/formatters";
//import {SlickGridEx1Component} from "../../../slick-grid-23/slick-grid-ex1.component";
import * as Popper from 'popper.js/dist/umd/popper';
import {CodeNameChartTabs} from "app/buffer-graph/models/code-name-chart-tabs";
import {CommonService} from "../../../services/common.service";
import {TabItem, TabItem2} from "app/buffer-graph/models/tab-item";
import {TabItem3} from "../../../buffer-graph/models/tab-item";
import {UniversalListSettings} from "../../models/universal-list";
import {Title} from "@angular/platform-browser";
import {observableToBeFn} from "rxjs/testing/TestScheduler";
import {forEach} from "@angular/router/src/utils/collection";
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {ISlickGridColumn} from "../../../slick-grid/interfaces/slick-grid-column";
import {SavedMPRegistry} from "../../../marketing-purchase/models/saved-m-p-registry";
import {SlickGridComponent} from "../../../slick-grid/slick-grid.component";
import {DataSorter} from 'app/slick-grid/models/data-sorter';
import {OrderItemBase} from "../../../orders/models/order-item-base";
import {Focus} from "../../../stocks/models/focus";

@Component({
    selector: 'universal-list',
    templateUrl: './universal-list.component.html',
    styleUrls: ['./universal-list.component.css']
})
export class UniversalListComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService,
                public readonly commonService: CommonService,
                ){

        this.selectionModel = new Slick.RowSelectionModel<any, Slick.Range[]>({selectActiveRow: false});
        this.selectionModelSelected = new Slick.RowSelectionModel<any, Slick.Range[]>({selectActiveRow: false});

        this.gridView = new Slick.Data.DataView<any>();
        this.cellCssStyles = {};
        this.gridView.onRowsChanged.subscribe(() => this.setMainGridSellStyles(this.gridView, this.cellCssStyles));
        this.cellCssStylesSelected = {};
        this.gridViewSelected = new Slick.Data.DataView<any>();
        this.gridViewSelected.onRowsChanged.subscribe(() => this.setMainGridSellStyles(this.gridViewSelected, this.cellCssStylesSelected));

       this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true,
        };

        this.optionsSelected = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true,
        };

        this.helper = new ChartHelper();
        this.hide = new EventEmitter<{data: any[], selected: any[]}>();
        this.sorter = new DataSorter<any>();
        this.loadingOutput = new EventEmitter<boolean>();

        this.commonData.translateService.get(['Remove']).subscribe(
            t => {
                this.translates = t;
            });
        // this.dataOutput = new EventEmitter<{data: CodeNameTranslateChartTabs, mode: number}>();
        this.initialise();
    }

    private initialise = (): void =>{
        this.selected = [];
        this.clonedInData = [];
        this.timeOut = null;
        this.checkBoxHeader = null;
        this.maxPosition = { position: 0 };
        this.inputClass = {};
        //this.sortField = 'selected';
    };

    @HostListener('window:mouseup', ['$event']) onMouseUp(e: MouseEvent){
        if (this.mouseDown && this.checkDimensionsChange()){
            this.mouseDown = false;
            this.resizeGrid(true)
        }
    }

    private checkDimensionsChange = (): boolean => {
        let height = this.mainWrapper.nativeElement.offsetHeight,
            width = this.mainWrapper.nativeElement.offsetWidth,
            changed = this.height !== height || this.width !== width;
        if (changed){
            this.height = height;
            this.width = width;
        }
        return changed;

    }



    @Input() private GUID: string;
    @Input() private addRef: ElementRef;
    @Input() private wrpRef: ElementRef;
    @Input() private inData: any[];
    @Input() public settings: UniversalListSettings;
    @Input() private columnSettings: ColumnSettingsBase[];
    @Input() private titleKey: string;
    @Input() public columns: ISlickGridColumn<any>[];
    @Input() private readonly sorter?: DataSorter<any>;

    @Input() public customSelect?: (data: any[], filteredData: any[], selected: any[], row: any, maxPosition: { position: number}, selectAll: boolean) => void;

    @Input() set updatePopper(val: number){
        console.log('updatePopper')
        this.popperAddVar ? this.popperAddVar.update() : null;

    };

    @Input() private readonly inClass?: string[];

    @Output()
    private readonly hide: EventEmitter<{data: any[], selected: any[]}>;

    @Output()
    private readonly loadingOutput: EventEmitter<boolean>;

    // @Output()
    // private readonly dataOutput: EventEmitter<{data: CodeNameTranslateChartTabs, mode: number}>;
    //
    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('gridsWrpEl')
    private gridsWrpRef: ElementRef;

    @ViewChild('itemsInfoEl')
    private itemsInfoRef: ElementRef;

    @ViewChild('gridWrpEl')
    private gridWrpRef: ElementRef;

    @ViewChild('gridWrpSelEl')
    private gridWrpSelRef: ElementRef;

    @ViewChild('grid')
    private grid: SlickGridComponent;

    @ViewChild('gridSelected')
    private gridSelected: SlickGridComponent;

    @ViewChild('inputSearchEl')
    private inputSearchEl: ElementRef;


    private readonly gridView: Slick.Data.DataView<TabItem>;
    private gridViewSelected: Slick.Data.DataView<TabItem>;
    private columnsGrid: Slick.Column<TabItem>[];
    private columnsGridSelected: Slick.Column<TabItem>[];
    private readonly options: Slick.GridOptions<TabItem>;
    private readonly optionsSelected: Slick.GridOptions<TabItem>;
    private readonly selectionModel: Slick.RowSelectionModel<TabItem, Slick.Range[]>;
    private readonly selectionModelSelected: Slick.RowSelectionModel<TabItem, Slick.Range[]>;
    private cellCssStyles: { [key: string]: Slick.CellCssStylesHash };
    private cellCssStylesSelected: { [key: string]: Slick.CellCssStylesHash};
    private data: any[];
    public _loading: boolean;
    private helper: ChartHelper;
    private subscriptionMouseMove: ISubscription;
    private popperAddVar: Popper;
    private translates: any;
    private listenMouseDown: () => void;
    private listenKeyboard: () => void;
    // private data: CompareItem[];
    private selected: any[];
    private filteredData: any[];
    private searchData: string;
    private mouseDown: boolean;
    private timeOut: any;
    private showActivity: boolean;
    public outline: boolean;
    private checkBoxHeader: any;
    private maxPosition: { position: number} ;
    public sizeStyles: object;
    public clonedInData: any[];
    public refreshGrids: boolean;
    public showSelectedGrid: boolean;
    public inputClass: {[index: string]: boolean};
    private subscription: ISubscription;
    private height: number;
    private width: number;
    private itemsInfoHeight: number;
    private gridHeight: number;
    private gridSelHeight: number;
    //public sortField: string;

    // private listenContextMenu: () => void;


    ngOnInit(){
        // console.log(this.settings, 'ngOnInit')
        this.settings.hideListenerOnDom
            ? this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e))
            : this.subscription = this.commonService.mouseDownCurrent.subscribe((e: MouseEvent) => this.helper.tryCatch(() => e ? this.hideList(e) : null))

        this.listenKeyboard = this.renderer.listen('body', 'keyup', (e: KeyboardEvent) => {
            if (e){
                switch (e.keyCode){
                    case 13:
                        this.apply('Apply');
                        break;
                    case 27:
                        this.clearSearch();
                        break;
                }
            }
        });

        // this.subscription = this.commonService.mouseDownCurrent.subscribe((e: MouseEvent) => e ? this.hideList(e) : null);

        // this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideList(e));
        // this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        this.subscriptionMouseMove = this.commonService.mouseMoveCurrent.subscribe(e =>
            this.helper.tryCatch(() => e && this.mouseDown && this.resizeGrid())
        );

        this.columnsGrid = this.columns.map(item => item);

        if (!this.settings.applyOneClick){
            this.columnsGrid.unshift({
                id: 'selected',
                field: 'selected',
                name: '<div class="out-chkb-wrp"><label class="chkb-wrp"><input tabIndex="-1" type="checkbox"><span></span></label></div>',
                sortable: false,
                width: 20,
                formatter: (r, c, v) => Formatters.checkBoxFormatter(r, c, v)
            });
        }

        this.columnsGridSelected = this.columns.map(item => item);
        this.columnsGridSelected.push({
            id: 'remove',
            field: 'remove',
            name: '',
            sortable: false,
            width: 50,
            formatter: (r, c, v) => this.formatRemoveCell(r, c, v),
            resizable: false
        });

      /*      [
            {
                id: 'selected',
                field: 'selected',
                name: '<div class="out-chkb-wrp"><label class="chkb-wrp"><input tabIndex="-1" type="checkbox"><span></span></label></div>',
                sortable: false,
                width: 20,
                formatter: (r, c, v) => Formatters.checkBoxFormatter(r, c, v)
            },
            {id: 'key', field: 'key', name: 'key', sortable: true, width: 220}
        ];*/


        //console.log(data, 'ngOnInit');

        // const data = allTabsData ? allTabsData.filter(item => item.GUID === this.GUID).find(item => !!item): null;

        // console.log(this.inData, 'universal init inData')

        this.data = this.clone(this.inData);
        this.filteredData = this.data;
        // console.log(this.filteredData, 'universal init filteredData')
        this.maxPosition.position = Math.max.apply(Math, this.data.map(o =>  o.position ));
        this.gridView.setItems(this.filteredData);

        this.selected = this.data.filter(item => item.selected);
        this.selected.sort((a: any, b: any) => {
            return a['position'] - b['position'];
        });
        this.gridViewSelected.setItems(this.selected);

        this.resizeGrid(true);
        this.helper.wait(() => this.setSelectedRows());

        this.sizeStyles = {
            'width': this.settings.startWidth + 'px',
            'height': this.settings.startHeight + 'px'
        };

        if (this.settings.changeSizes) {
            this.sizeStyles['min-width'] = this.settings.minWidth + 'px';
            this.sizeStyles['min-height'] = this.settings.minHeight + 'px';
            this.sizeStyles['max-width'] = this.settings.maxWidth + 'px';
            this.sizeStyles['max-height'] = this.settings.maxHeight + 'px';
        }

        if (this.settings.openSelectedList){
            this.showSelectedGrid = true;
        }

        this.generateClass();
    }

    ngOnDestroy(){
        this.listenMouseDown && this.listenMouseDown();
        this.listenKeyboard && this.listenKeyboard();
        this.subscription && this.subscription.unsubscribe();
    }

    async ngAfterViewInit(){
        //this.helper.wait(() => this.setCellStyles());

        this.popperAdd();

        if (this.inputSearchEl && this.inputSearchEl.nativeElement) {
            this.helper.wait(() => this.inputSearchEl.nativeElement.focus());
        }
    }

    async ngAfterViewChecked(){
        if (this.refreshGrids){
            this.refreshGrids = false;
            if (this.grid){
                this.grid.resizeGrid();
            }
            if (this.gridSelected){
                this.gridSelected.resizeGrid();
            }
        }
    }

    private clone = (data: any[]): any[] => {
        if (this.settings.cloneIncomingData) {
            data.forEach((element: any) => {
                let obj: any = element.clone ? element.clone() : this.helper.deepCopy(element);
                this.clonedInData.push(obj);

            });

            // console.log(this.clonedInData, 'this.clonedInData')

            return this.clonedInData;
        }

        return data;
    }

    //# set filter on grid
    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }
        this.grid ? this.grid.setFreezeColumns(this.settings.frozenColumnsNum) : null;
        this.gridView.setFilter(o => this.grid.filterHelper.filter(o));
    }

    //# set filter on grid
    public setFilterSelected = (val: boolean): void => {
        if (!val){
            return;
        }
        this.gridViewSelected.setFilter(o => this.gridSelected.filterHelper.filter(o));
    }

    //# load list of tabs
    /*private loadData = async (): Promise<void> =>{
        this.loading = true;
        let list: CodeNameChartTabs = await this.helper.getDefaultTabsList(this.GUID, this.translateService, this.graphService, this.commonData);
        //this.dataExchange.setTabsList(list);
        this.data = list.clone();
        this.filteredData = this.data.tabs;
        this.loading = false;
        this.gridView.setItems(this.filteredData);
    }*/

    //# toggle tab selection
    public onGridClick = (args: any): void =>{
        let data = this.gridView.getItem(args.data.row),
            el = args.event.target,
            row = args.data.row;
        this.gridView.getItem(args.data.row);
        if (el.tagName.toLowerCase() === 'input'){
            return;
        }

        if (this.settings.applyOneClick){
            this.selected.length = 0;
            this.data.forEach(item => item.selected = false );
        }

        this.selectRow(data);
        this.grid.updateRow(row);

        this.gridViewSelected ? this.gridViewSelected.setItems(this.selected) : null;

        if (this.settings.applyOneClick) {
            this.apply('Apply');
        }
    };

    //# toggle tab selection
    public onGridClickSelected = (args: any): void =>{
        let data = this.gridViewSelected.getItem(args.data.row),
            el = args.event.target,
            row = args.data.row;

        if (el.classList.contains('fa-times')){
            this.selectRow(data);
            this.grid.updateRow(row);

            this.gridViewSelected.setItems(this.selected);
            return;
        }
    };

    public sortColumns = (columns: Slick.Column<any>[]): void => {
        columns.sort((a: any, b: any) =>{
             return a.id === 'selected' ? - 1 : b.id === 'selected' ? 1 : 0;
        });
    };

    public sortColumnsSelected = (columns: Slick.Column<any>[]): void => {
        columns.sort((a: any, b: any) =>{
            return a.id === 'remove' ? 1 : b.id === 'remove' ? -1 : 0;
        });
    };

    //# toggle select for row in grid
    public selectRow = (row: any, node?: HTMLElement): void =>{
        row.selected = !row.selected;
        if (row.selected){
            this.maxPosition.position =  row.position = ++this.maxPosition.position;
        }
        row.selected ? this.selected.push(row) : this.helper.remFromArr(this.selected, 'id', row.id);
        this.customSelect ? this.customSelect(this.data, this.filteredData, this.selected, row, this.maxPosition, null) : null;
        this.setSelectedRows();
    };

    //# set selected row in grid, set to selected row color
    private setSelectedRows = (): void =>{
        let selected = this.helper.getRowsFromGridAll(this.gridView).filter(item => item.selected),
            id = selected.map(item => this.gridView.getRowById(item.id.toString()));
        if (this.grid){
            // this.grid.setSelectedRows(id);
            this.grid.invalidate();
        }

        !this.settings.applyOneClick && this.checkAllSelect();
    };

    //# if all tabs is selected we set "all select" checkbox checked, in otherwise set "all select" checkbox not checked.
    private checkAllSelect = (): void =>{
        let allSelected = this.filteredData.length ? this.helper.getRowsFromGridAll(this.gridView).every(item => item.selected) : false;
        if (this.checkBoxHeader){
            this.helper.wait(() => allSelected ? this.checkBoxHeader.checked = true : this.checkBoxHeader.checked = false);
        }
    };

    public onGridDblClick = (args: any): void =>{

    };

    //# enable loading image in inform about it parent component
    set loading(val: boolean){
        if (val !== this._loading){
            this._loading = val;
            this.helper.wait(() => this.loadingOutput.emit(val));
        }
    }

    get loading(): boolean{
        return this._loading;
    }

    //# add listener to "select all" checkbox
    public slickGridHeaders = (args: any): void =>{
        if (args.data.column.id === 'selected'){
            this.checkBoxHeader = args.data.node.querySelector('input');
            this.renderer.listen(this.checkBoxHeader, 'change', e => this.selectAll(e.target.checked));
        }
    };

    //# toggle all select
    private selectAll = (select: boolean): void =>{
        let items = this.helper.getRowsFromGridAll(this.gridView);

        items.forEach(item =>{
            item.selected = select;
            if (select){
                let has: boolean = this.selected.some(inItem => item[this.settings.selectAllField] === inItem[this.settings.selectAllField]);

                !has ? this.selected.push(item) : null;
                !has ? this.maxPosition.position = item.position = ++this.maxPosition.position : null

            } /*else{
                this.data.selected.forEach(inItem => item.code === inItem.code ? has = true : null);
                has ? this.helper.remFromArr(this.data.selected, 'code', item.code) : null;
            }*/
        });

        !select ? this.selected.length = 0 : null;

        // this.data.selected.length = 0;
        //this.gridView.setItems([]);
        this.gridView.setItems(this.filteredData);
        this.gridViewSelected.setItems(this.selected);
        this.setSelectedRows();
    };

    //# add popper to this component
    public popperAdd = (): void =>{
        // console.log(this.addRef, this.wrpRef, 'popperAdd')
        this.popperAddVar = this.helper.popperAdd(this.addRef, this.mainWrapper, this.wrpRef, this.settings.popper.placement, this.settings.popper.behavior, true);

        //this.helper.wait(() => this.popperAddVar.update(), 500)

        /*this.popperAddVar = new Popper(this.addRef && this.addRef.nativeElement ? this.addRef.nativeElement : this.addRef, this.mainWrapper.nativeElement.parentElement, {
            placement: 'bottom-start',
            modifiers: {
                flip: {
                    behavior: ['bottom', 'bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.wrpRef,
                    padding: 0
                },
            },
        });

        this.helper.wait(() => this.popperAddVar.update(), 5)*/
    };

    //# hide list
    private hideList = (e: MouseEvent): void =>{

        let clickOnList = this.helper.hideList(this.mainWrapper, e, this.renderer);

        console.log(clickOnList, 'hideList clickOnList')

        if (clickOnList){

            this.helper.wait(() =>{
                this.settings.emitOnClose
                    ? this.settings.disableOkNoneSelected && !this.selected.length
                        ? this.hide.emit(null)
                        : this.hide.emit({data: this.data, selected: this.selected})
                    : this.hide.emit(null);
            }, 250);
        } else {
            this.mouseDown = true;
            this.height = this.mainWrapper.nativeElement.offsetHeight;
            this.width = this.mainWrapper.nativeElement.offsetWidth;
        }
    };

    //# search in list
    public filterSearch = (e?: KeyboardEvent, keyDown?: boolean): void =>{

        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 17 || e.keyCode === 18)) return;

        if (e && e.keyCode === 27 && !keyDown){
            return;
        }

        if (e && e.keyCode === 9 && this.loading){
            e.preventDefault();
            return;
        }

        if (e && e.keyCode === 9 && e.repeat){
            e.preventDefault();
            return;
        }

        let data: string[] = [];
        if (this.searchData && !keyDown){
            data = this.searchData.split(' ').map(item => item.trim());
        }

        if (this.data && this.data.length > 0 && !keyDown){

            if (this.searchData && this.searchData.length > 0){
                this.filteredData = this.data.filter(item =>{
                    let propArr: string[] = []
                    for (let prop in item){
                        if (typeof item[prop] === 'string'){
                            item[prop + 'Find'] = this.helper.matchText(data, item[prop]);
                            propArr.push(prop + 'Find')
                        }
                    }
                    // item.findCode = this.helper.matchText(data, item.code);
                    // item.findName = this.helper.matchText(data, item.name);
                    // return item.findCode || item.findName;
                    return propArr.some(p => item[p] );
                });
            } else{
                this.data.forEach(item =>{
                    for (let prop in item){
                        // let found = prop.match(/[\w\-]+Find/);
                        if (prop.substr(prop.length - 4) === 'Find'){
                            item[prop] = false;
                        }
                    }
                    // item.findCode = false;
                    // item.findName = false;
                });
                this.filteredData = this.data;
            }

            this.gridView.setItems([]);
            this.gridView.setItems(this.filteredData);

            //this.columnWidth();
            this.setCellStyles();
        }
    };

    //# set color for grid sells
    private setCellStyles = (): void =>{
        let mainStyles = null;

        this.filteredData.forEach((row: CodeNameTranslate) => mainStyles = this.setCellMainStyles(mainStyles, row, this.gridView.getIdxById(String(row.id))));
        const styles = {};
        if (mainStyles === null) mainStyles = {};
        styles['main-styles'] = mainStyles;
        this.cellCssStyles = styles;

    };

    //# generate colors for grid sells on row
    private setCellMainStyles = (hash: Slick.CellCssStylesHash, row: any, index: number): Slick.CellCssStylesHash =>{
        let styles = null;

        for (let prop in row){
            //let found = prop.match(/[\w\-]+Find/);
            // if (found && row[prop]){
            if (prop.substr(prop.length - 4) === 'Find' && row[prop]){
                let key = prop.slice(0, -4),
                    styleObj = {};
                styleObj[key] = 'found';
                styles = Object.assign(styles || {}, styleObj);
            }
            if (row['selected']){
                let styleObj = {};
                styleObj[prop] = 'selected';
                styles = Object.assign(styles || {}, styleObj);
            }
        }

        // if (row.findCode)
        //     styles = Object.assign({}, {code: 'found'});
        //
        // if (row.findName)
        //     styles = Object.assign(styles || {}, {name: 'found'});

        if (!styles)
            return hash;

        if (!hash)
            hash = {};
        hash[index] = styles;

        return hash;
    };

    //# ask question in which mode open tabs
    /*public showSelect = (): void =>{
        let first: string = 'OpenTabsInSingleMode',
            second: string = 'OpenTabsInViewMode';
        if (this.data.viewMode === null && this.data.selected.length > 1){
            this.translateService.get([first, second])
                .subscribe(s => this.commonData.showRadioSelection([s[first], s[second]], (idx: number) => this.apply('Apply', idx)));
            return;
        } else {
            let mode = this.data.viewMode === null ? 1 : this.data.viewMode;
            this.apply('Apply', mode)
        }
    };*/

    //# apply selection
    public apply = (command: string, mode: number = null): void =>{
        switch (command){
            case 'Apply':
                this.hide.emit({data: this.data, selected: this.selected});
                /*mode !== null ? this.data.viewMode = mode : null;*/
                console.log(this.data, 'apply tab list')
                /*this.dataExchange.setTabsList(this.data);*/
                break;
            case 'Cancel':
                this.hide.emit(null );
                /*mode !== null ? this.data.viewMode = mode : null;*/
                console.log(this.data, 'apply tab list')
                /*this.dataExchange.setTabsList(this.data);*/
                break;
            default:
                this.hide.emit(null );
                /*mode !== null ? this.data.viewMode = mode : null;*/
                console.log(this.data, 'apply tab list')
                /*this.dataExchange.setTabsList(this.data);*/
                break;
        }
        /*this.helper.wait(() => this.hide.emit(true), 10)*/

    };

    public clearSearch = (): void => {
        this.searchData = '';
        this.filterSearch();
    }

    //# resize grid when dimensions of wrapper changing
    public resizeGrid = (last?: boolean): void =>{
        if (this.grid && this.mouseDown){
            if (this.timeOut){
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }

            this.timeOut = setTimeout(() =>{
                //this.columnWidth();
                this.grid.resizeGrid();
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }, 100);
        } else if (this.grid && last){
            this.helper.wait(() => this.columnWidth());
        }
    };

    //# recalculate grid column width when dimensions of wrapper changing
    private columnWidth = (): void =>{
        if (!this.gridWrpRef || !this.grid){
            return;
        }

        let slickScrollWidth = 8,
            gridWidth = this.gridWrpRef.nativeElement.offsetWidth - 2,
            gridHeight = this.gridWrpRef.nativeElement.offsetHeight,
            sumColumnWidth = 0;
        let stringQuantity = Math.floor((gridHeight - 5) / 25) - 1;
        if (this.filteredData.length > stringQuantity){
            gridWidth = gridWidth - slickScrollWidth;
        }

        this.columnsGrid.forEach(item => sumColumnWidth += item.width);

        if (sumColumnWidth < gridWidth){
            //let lasrColWidth = this.columnsGrid[this.columnsGrid.length - 1].width;
            this.columnsGrid[this.columnsGrid.length - 1].width += gridWidth - sumColumnWidth;
        } else if (sumColumnWidth > gridWidth){

        }



        // this.columnsGrid.forEach(item =>{
        //     if (item.field !== 'name'){
        //         width = width - item.width;
        //     }
        // });
        //
        // this.columns.forEach(item =>{
        //     if (item.field === 'name' && width > 100){
        //         item.width = width;
        //     }
        // });

        this.grid.setColumns(this.columnsGrid);


        this.grid.resizeGrid();
        this.gridSelected && this.gridSelected.resizeGrid();
        this.checkAllSelect();
        // this.popperAddVar.destroy();
        // this.popperAdd();
    }

    public onGridKeyDown = (args: any): void =>{
        if (args.event.keyCode === 32){
            this.onGridClick(args);
            // let data = this.gridView.getItemByIdx(args.data.row),
            //     row = args.data.row;
            // console.log(args,'onGridKeyDown 2');
            // let item = this.gridView.getItem(args.data.row);
            // if (this.type === 1){
            //     item.selected ? this.removeSelected([item.code]) : this.addClickSelected([item.code]);
            // } else{
            //     item.selected ? this.removeSelected([item.name]) : this.addClickSelected([item.name]);
            // }
            //
            // item.selected = !item.selected;


            // this.selectRow(data);
            // this.grid.updateRow(row);


        } else if (args.event.keyCode === 13){
            // this._showSearch = false;
            // this.showGrid = false;
            // this.clearSearchFilter();
            //this.inputDataEl.nativeElement.focus();
        } else if (args.event.keyCode === 27){
            // this.clearSearchFilter();
            // this._showSearch = false;
        } else if (args.event.keyCode === 9 && args.event.originalEvent.shiftKey && args.event.originalEvent.repeat){
            // args.event.originalEvent.preventDefault();
        } else if (args.event.keyCode === 9 && args.event.originalEvent.shiftKey){
            /*args.event.originalEvent.preventDefault();
            let timeOut = setTimeout(() => {
                clearTimeout(timeOut);
                timeOut = null;
                this.inputSearchEl.nativeElement.focus();
            },0);*/

        } else if (args.event.keyCode === 9 && args.event.originalEvent.repeat){
            // args.event.originalEvent.preventDefault();
            // this.inGrid = true
        } else if (args.event.keyCode === 9){
            //console.log(args.event);
            /*if (this.inGrid) {
                this.clearSearchFilter();
                args.event.preventDefault();
                this._showSearch = false;
                this.showGrid = false;
                this.filterService.setGoToNextFilter2({ GUID: this.GUID, focus: new Focus(this.param, 'next') });
            }
            this.inGrid = true*/
        }
    };

    //# render icon for remove
    private formatRemoveCell = (r, c, v): string => {
        return `<span class="fa fa-times fa-fw" data-toggle="tooltip" title="${this.translates['Remove']}" style="cursor: pointer"></span>`;
    };

    private toggleSelectedTable = (e) => {
        this.showSelectedGrid = !this.showSelectedGrid;
        this.refreshGrids = true;
    }

    private generateClass = (): any =>{
        this.inClass && this.inClass.length ? this.inClass.forEach(item => this.inputClass[item] = true) : null;
    }

    protected setMainGridSellStyles = (view: Slick.Data.DataView<TabItem>, stylesObj: { [key: string]: Slick.CellCssStylesHash}): void => {
        this.helper.setCellStyles(view, stylesObj);
    }

    public searchBlur = (): void => {
        this.outline = false
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/universal-list.component/universal-list.component.ts